import { useMutation } from "react-query";
import disburseDistributorFunds from "../services/disburseDistributorFunds";

function useDisburseDistributorFunds() {
  return useMutation(["disburse-distributor-funds"], disburseDistributorFunds);
}

export default useDisburseDistributorFunds;
